import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
`;

export const EditHeaderWrapDiv = styled.div`
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
`;
export const AddLink = styled(Link)`
  height: 40px;
  background-color: #1B49EA;
  color: #ffffff;
  border-radius: 8px;
  padding: 8px 17px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  text-decoration: none;
  box-sizing: border-box;
  & > span {
    height: 15px;
    overflow: hidden;
    margin-right: 8px;
    margin-bottom: 3px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  &:hover {
    color: #ffffff;
  }
`;
export const FilterWrapDiv = styled.div`
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 36px;
  margin-bottom: 20px;
  & input {
    width: 115px;
    margin-right: 12px;
  }
  & > div {
    margin-right: 12px;
  }
`;
export const SearchDiv = styled.div`
  position: relative;
  & img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  & input {
    height: 38px;
    width: 200px;
    margin: 0px;
    padding: 0px 12px 0px 40px;
  }
`;
export const CardDiv = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: 0px 36px auto 36px;
`;
export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-right: 10px;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked ~ span {
      background-color: #21C17A;
    }
    &:checked ~ span:before {
      -webkit-transform: translateX(15px);
      -ms-transform: translateX(15px);
      transform: translateX(15px);
    }
    &:focus ~ span{
      box-shadow: 0 0 1px #21C17A;
    }
  }
  & span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #C4C6CB;
    -webkit-transition: .2s;
    transition: .2s;
    border-radius: 34px;
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 4px;
      bottom: 3px;
      background-color: white;
      -webkit-transition: .2s;
      transition: .2s;
      border-radius: 50%;
    }
  }
`;
export const TestWrapDiv = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  padding: 30px;
  border-bottom: 1px solid #ECECEC;
`;
export const TestImage = styled.img`
  height: 132px;
  width: 274px;
  flex-shrink: 0;
  background-color: #ebebeb;
  border-radius: 6px;
`;
export const TestColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TestActionWrapDiv = styled.div`
  display: flex;
  margin: 14px 0px auto 0px;
`;
export const ActionButton = styled.button`
  margin-left: 8px;
  padding: 6px;
  border-radius: 4px;
  background-color: #ffffff;
  &:hover {
    background-color: #F7F8F9;
  }
  & img {
    height: 20px;
    width: 20px;
  }
`;
export const ActionLink = styled(Link)`
  margin-left: 8px;
  padding: 6px;
  border-radius: 4px;
  background-color: #ffffff;
  &:hover {
    background-color: #F7F8F9;
  }
  & img {
    height: 20px;
    width: 20px;
  }
`;
export const TestSwitchDiv = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  margin-top: auto;
`;
export const TestInfoWrapDiv = styled.div`
  display: flex;
  align-items: center;
  color: #939599;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin: 20px 0px;
  & div {
    display: flex;
    align-items: center;
    margin-right: 25px;
  }
  & img {
    width: 13px;
    height: 13px;
    margin-right: 7px;
  }
`;
export const TestHeadingP = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  margin: 0px;
`;
export const TestUpdateDiv = styled.div`
  color: #939599;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
`;

export const TagSpan = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  padding: 4px 7px;
  border-radius: 4px;
  margin-left: 9px;
  color: ${props => props.tagStyle && props.tagStyle.color};
  background-color: ${props => props.tagStyle && props.tagStyle.backgroundColor};
  border: ${props => props.tagStyle && props.tagStyle.border};
`;

export const SaveWrapDiv = styled.div`
  border-top: 1px solid #ECECEC;
  padding: 30px 30px 45px 30px;
  display: flex;
  align-items: center;
  margin-top: 40px;
`;
export const SaveButton = styled.button`
  width: 161px;
  height: 56px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #1B49EA;
  margin-right: 10px;
`;

export const InputTitleDiv = styled.div`
  width: 200px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  padding: 10px 0;
`;

export const InputWrap = styled.div`
  display: flex;
  padding: 10px 30px;
  column-gap: 100px;
  & input {
    width: 600px;
    height: 55px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    padding: 13px 15px;
    font-family: sans-serif;
    line-height: 18px;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;

export const CoverImageWrapDiv = styled.div`
  width: 600px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F6FAFF;
  border: 1px dashed #D9D9D9;
  border-radius: 10px;
  font-size: 12px;
  color: #506D85;
  padding: 20px 0;
    & img {
      width: 16px;
      height: 15px;
      margin-right: 6px;
    }
  }
`;

export const SaveErrorDiv = styled.div`
  font-size: 14px;
  color: #E74C3C;
  padding-top: 2px;
  margin-left: 12px;
`;

export const CoverImageLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  background: #1B49EA;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: "Arial";
  cursor: pointer;
`;

export const CoverImageInput = styled.input`
  display: none;
`;


export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #E74C3C;
  padding-top: 2px;
`;

export const EditorWrap = styled.div`
  padding: 0px 30px 10px 30px;
`;
export const MetaTitle=styled.div`
  width: 200px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  padding: 10px 0;
`